import { IconButton } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export type KintsugiAiIconTriggerProps = {
  icon: ReactNode;
  /** Shown to assistive tech (tooltip text is usually supplied by the app `Tooltip`). */
  ariaLabel: string;
  onClick: () => void;
  /**
 * When true, icon is hidden on fine-pointer hover devices until the parent `group` row is hovered or focused; always visible on touch / coarse pointer.
 */
  inactive?: boolean;
};

export function KintsugiAiIconTrigger({ icon, ariaLabel, onClick, inactive }: KintsugiAiIconTriggerProps) {
  return (
    <IconButton
      minW="initial"
      flexShrink={0}
      variant="ghost"
      onClick={onClick}
      aria-label={ariaLabel}
      {...(inactive && {
        css: {
          opacity: 1,
          '@media (hover: hover) and (pointer: fine)': {
            opacity: 0,
            '.group:hover &': { opacity: 1 },
          },
          '&:focus-visible': { opacity: 1 },
        },
      })}
    >
      {icon}
    </IconButton>
  );
}
